mutation ResolveYouTubeChatSource($videoUrl: String!) {
  result: StreamToolsResolveYouTubeChatSource(videoUrl: $videoUrl) {
    resolved
    refusalCode
    message
    channelId
    channelTitle
    channelProfileImageUrl
    videoId
    live
  }
}
